import { render, staticRenderFns } from "./questionEdit.vue?vue&type=template&id=8a62f356&scoped=true"
import script from "./questionEdit.vue?vue&type=script&lang=js"
export * from "./questionEdit.vue?vue&type=script&lang=js"
import style0 from "./questionEdit.vue?vue&type=style&index=0&id=8a62f356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a62f356",
  null
  
)

export default component.exports